<template>

   <div class="container mb-5">
       <div class="title">Actualités</div>
       <div class="highlighted">Retrouvez ici les publications sur nos innovations et sur l'univers digital agricole</div>
       <div class="row">
           <div class="actuBloc articleEchangeSem23 col-md-4">
               <a target="blank" href="https://www.linkedin.com/pulse/le-digital-au-service-de-la-coop%25C3%25A9ration-agricole-agrivitech/?trackingId=XvcxJZ8qKU54JNftLf4e6g%3D%3D" class="overlay"><i class="fas fa-plus-circle"></i></a>
               <div class="actuTitle">Article : Le digital au service de la coopération agricole</div>
           </div>
           <div class="actuBloc sia23 col-md-4">
               <a target="blank" href="https://www.linkedin.com/feed/update/urn:li:activity:7036270957300215808" class="overlay"><i class="fas fa-plus-circle"></i></a>
               <div class="actuTitle">Retour sur notre présence au Salon de l'Agriculture 2023 !</div>
           </div>
           <div class="actuBloc agrisudouest23 col-md-4">
               <a target="blank" href="https://www.linkedin.com/feed/update/urn:li:activity:7032289409483862016" class="overlay"><i class="fas fa-plus-circle"></i></a>
               <div class="actuTitle">AgriVitech devient membre AGRI SUD-OUEST INNOVATION !</div>
           </div>
            <div class="actuBloc lfday22 col-md-4">
               <a target="blank" href="https://www.linkedin.com/posts/agrivitech_agrivitech-lfday-2022-activity-6942824612686655488-zRqk?utm_source=linkedin_share&utm_medium=member_desktop_web" class="overlay"><i class="fas fa-plus-circle"></i></a>
               <div class="actuTitle">Quelques images du LFDay 2022 !</div>
           </div>
           <div class="actuBloc refagrodapceresia col-md-4">
               <a target="blank" href="https://www.reference-agro.fr/chez-ceresia-digitappro-facilite-le-reappro/" class="overlay"><i class="fas fa-plus-circle"></i></a>
               <div class="actuTitle">Référence Agro : Chez Cérèsia, DigitAppro facilite le réappro.</div>
           </div>
           <div class="actuBloc vivcer col-md-4">
               <a target="blank" href="https://abonne.lunion.fr/id265556/article/2021-06-14/ceresia-et-vivescia-concurrents-mais-partenaires" class="overlay"><i class="fas fa-plus-circle"></i></a>
               <div class="actuTitle">L'UNION : Cérèsia et Vivescia : concurrents mais partenaires.</div>
           </div>
           <div class="actuBloc culturales2021 col-md-4">
               <a target="blank" href="https://www.lesculturales.com/" class="overlay"><i class="fas fa-plus-circle"></i></a>
               <div class="actuTitle">AgriVitech participe aux Culturales les 15-16-17 Juin 2021.</div>
           </div>
           <div class="actuBloc col-md-4 videobe">
               <router-link to="/solutions/boursedechange" class="overlay"><i class="fas fa-plus-circle"></i></router-link>
               <div class="actuTitle"> Présentation vidéo de la solution Bourse d'Echange Semences à la coopérative Cérésia.</div>
           </div>
           <div class="actuBloc col-md-4 bevv1">
               <router-link to="/actualites/bourse-vivescia" class="overlay"><i class="fas fa-plus-circle"></i></router-link>
               <div class="actuTitle">Vivescia lance sa Bourse aux Semences, solution Agrivitech, pour les échanges entre agriculteurs</div>
           </div>
           <div class="actuBloc col-md-4 fleet">
               <div class="overlay"><i class="fas fa-plus-circle"></i></div>
               <div class="actuTitle">Seveal s'équipe de la solution Fleet</div>
           </div>
           <div class="actuBloc col-md-4 terreinno2021">
               <div class="overlay"><i class="fas fa-plus-circle"></i></div>
               <div class="actuTitle">(Annulé) Terre Innovation - le grand rassemblement agricole de la Marne</div>
           </div>
           <div class="actuBloc col-md-4 vbca">
               <div class="overlay"><i class="fas fa-plus-circle"></i></div>
               <div class="actuTitle">Agivitech est fier d'être membre du Village by CA</div>
           </div>
       </div>
   </div>
   <MailjetNewsLetter/>
</template>

<script >
import MailjetNewsLetter from '../components/MailjetNewsLetter'

export default {
    name: 'News',
    components:{
        MailjetNewsLetter
    },
    props:{}
}
</script>

<style lang="scss" scoped> 

.actuBloc{
    padding: 20px;
    border-radius: 18px;
    border: white solid 10px;
    background-color: var(--mainGreen);   
    height: 350px;
    // opacity: 0.8;
    background-size: cover;
    background-position: center;
    background-image: url('../assets/img/illustrations/cereals.jpg');
    &.lfday22{
        background-image: url('../assets/img/presse/lfday22.jpg');
    }
    &.refagrodapceresia{
        background-image: url('../assets/img/presse/caroRefAgro22.jpg');
    }
    &.vivcer{
        background-image: url('../assets/img/presse/Luion1506Vivescia et Ceresia.jpg');
    }
    &.bevv1{
        background-image: url('../assets/img/presse/032021bourseechange1.jpg');
    }
    &.videobe{
        background-image: url('../assets/img/presse/videobe.png');
    }
    &.fleet{
        background-image: url('../assets/img/presse/fleet.jpg');
    }
    &.vbca{
        background-image: url('../assets/img/presse/vbca.png');
    }
    &.terreinno2021{
        background-image: url('../assets/img/presse/terrinno2021.png');
    }
    &.culturales2021{
        background-image: url('../assets/img/presse/culturales2021.jpg');
    }
    &.sia23{
        background-image: url('../assets/img/presse/sia23.jpg');
    }
    &.articleEchangeSem23{
        background-image: url('../assets/img/presse/echangesem23.png');
    }
    &.agrisudouest23{
        background-image: url('../assets/img/partners/agrisudouest.jpg');
    }
    
    .actuTitle{
        font-weight: 600;
        font-size: 18px;
        background: linear-gradient(transparent,var(--mainBlue)); 
        padding: 5px;
        bottom: 0;
        position: absolute;
        left: 0;
        color: white;
        border-radius: 8px;
        padding: 20px;
        width: 100%;
    }
    .overlay{
        background-color: var(--mainBlue);
        position: absolute;
        height: 330px;
        width: 100%;
        border-radius: 8px;
        opacity: 0.0;
        top: 0;
        left: 0;
        color: white;
        font-size: 90px;
        text-align: center;
        padding-top: 100px;
        &:hover{
            opacity: 0.7;
            cursor: pointer;
        }
        
    }
}



</style>